<template>
  <div>
    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="plus" @click="visible = true">
          新增审批人
        </a-button>
        <a-table
          :columns="columns"
          :pagination="true"
          :data-source="data"
          :row-key="record => record.name"
        >
          <template slot="action" slot-scope="text, record">
            <a-button @click="deleteId(record.name)">
              删除
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>
    <a-modal
      title="新增审批人"
      :visible="visible"
      @ok="handleOk"
      @cancel="visible = false"
    >
      <a-form-model :model="form">
        <a-form-model-item label="担保审批人">
          <a-input v-model="form.name" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '担保审批人',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '编辑',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  data() {
    return {
      columns,
      visible: false,
      data: [
        {
          name: '111111111',
        },
        {
          name: '2222222222',
        },
        {
          name: '3333333333',
        },
        {
          name: '444444444',
        },
        {
          name: '5555555555',
        },
      ],
      form: {
        name: '',
      },
    }
  },
  methods: {
    handleOk() {
      this.visible = false
    },
    deleteId(name) {
      console.log(name)
    },
  },
}
</script>
<style lang="less" scoped></style>
